import React, { Fragment } from 'react';
import $ from 'jquery';

import { EVENTS } from '../../utilities/CONSTANTS';

class AuthorName extends React.Component {
    componentDidMount() {
        if (!window._tettraUsers) {
            window.addEventListener(EVENTS.USERS_LOADED, () => this.forceUpdate());
        }
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.USERS_LOADED, () => this.forceUpdate()); }

    getUser = () => {
        const { userId } = this.props;
        if (!userId || !window._tettraUsers) return null;
        return window._tettraUsers.find(user => userId === user.id);
    };

    render() {
        const user = this.getUser();
        if (!user) return null;
        const { display_name = '' } = user;

        return (
            <Fragment>
                { window.userId === user.id
                    ? 'yourself'
                    : `${display_name}`}
            </Fragment>
        );
    }
}

class PageThankYousContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            submitting: false,
            thankYouId: null,
            pageId: null,
            revisionId: null,
            userId: null,
        };
    }

    static getDerivedStateFromProps(props, prevState) {
        const { page } = props;
        if (page && page.id != prevState.pageId) {
            return {
                pageId: page.id,
                revisionId: page.revision_id,
                userId: page.user_id,
            };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.pageId !== prevState.pageId) {
            this.setState({
                submitting: false,
                thankYouId: null,
            });
        }
    }

    toggleThankYou = () => {
        const {
            submitting, thankYouId, pageId, revisionId, userId,
        } = this.state;

        if (submitting) {
            return;
        }

        const url = thankYouId
            ? `/api/teams/${window.teamId}/pages/${pageId}/thank-yous/${thankYouId}`
            : `/api/teams/${window.teamId}/pages/${pageId}/thank-yous`;
        const method = thankYouId ? 'DELETE' : 'POST';
        const _token = window.csrfToken;
        const data = thankYouId ? '' : {
            thanker_user_id: window.userId, thanked_user_id: userId, revision_id: revisionId, _token,
        };

        $.ajax({
            type: method,
            url,
            data,
        }).done((response) => {
            if (response.success) {
                if (response.page_thank_you) {
                    return this.setState({
                        thankYouId: response.page_thank_you,
                    });
                }
                return this.setState({
                    thankYouId: null,
                });
            }
        }).catch(console.error)
            .always(() => {
                this.setState({ submitting: false });
            });
    };

    render() {
        const { submitting, thankYouId, userId } = this.state;

        const thankedClass = thankYouId ? 'thank-owner__thanked' : '';
        const submittingClass = submitting ? 'thank-owner__submitting' : '';
        const thankedText = thankYouId ? 'Thanked' : 'Thank';

        return (
            <button
                className={`thank-owner__btn ${thankedClass} ${submittingClass}`}
                type="button"
                onClick={this.toggleThankYou}
            >
                <span role="img" aria-hidden="true">🙏</span>
                {thankedText}
                {' '}
                <AuthorName userId={userId} />
            </button>
        );
    }
}

export default PageThankYousContainer;
